// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__3CxdS","path":"style_path__2MkPu","arrow":"style_arrow__3fZ-h"};